import React, { useEffect, useState, } from "react";
import { useHistory } from "react-router-dom";
import AdminS from "layouts/AdminS";
import Footer from "components/Footer/Footer";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";
import { createPrinter } from "typescript";

import firebase from "../firebase";

const UserApprove=()=> {

  let history = useHistory();
  
//Stroring Reteriwing Data
const[userData,setUserData]= useState([]);

useEffect(()=>{

  const files = firebase.database().ref("UserRegistration");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    setUserData(dataList);
    console.log(dataList);
  }) 
    
},[]);

const filterData=(datas,searchKey)=>{

  const result = datas.filter(
    (data)=>
    data.nIC.toLowerCase().includes(searchKey)
    // data.Age.toLowerCase().includes(searchKey)
     //Searching via 
  );
  setUserData(result);
}

const Changestatus = (id,status) =>{
  const files = firebase.database().ref("UserRegistration").child(id);
  
  let data = {
    Status:status, 
  };
  files.update(data);
  if(status == 1){
    alert("Activated");
  }
  else if(status == 0){
    alert("Deactivated");
  } 
}

const handleInput=(e)=>{
  const searchKey = e.currentTarget.value;

  const files = firebase.database().ref("UserRegistration");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    filterData(dataList, searchKey);
  })    
}
  return (
    <>
    <AdminS/>

<br/>


<Container>

  <Row>
    <Col md={{ span: 12, offset: 1 }}>  
    <Container fluid>
<FormControl
    type="search"
    placeholder="Search by NIC" 
    className="mr-2"
    aria-label="Search"
    name="searchQuery"
    onChange={handleInput}
  />
 <br/>
        <Table className = "text-center" striped bordered hover>
        <thead>
            <tr>
            <th>Index</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Address</th>
            <th>NIC</th>
            <th>Phone Number</th>
            <th><center>Action</center></th>
            </tr>
        </thead>
        <tbody>{userData.map((data, index)=>(
            <tr>
            <td>{index + 1}</td>
            <td>{data.FName}</td>
            <td>{data.LName}</td>
            <td>{data.address}</td>
            <td>{data.nIC}</td>
            {/* Metana Change karaddi Aniva ballane in Intergration Coloumn shouldbe changed */}
            <td>{data.phone_number}</td>
            {/* <td>{data.email}</td> */}
          
            <center>
            <Button onClick={()=>Changestatus(data.id,1)}  className = "mx-2" variant="primary" size="" active>
              Activate
            </Button>{' '}
            <Button onClick={()=>Changestatus(data.id,0)} className = "ml-2 mr-0" variant="primary" size="" active>
              Deactivate 
            </Button>
            </center>
            </tr>
            ))}
        </tbody>
        </Table>
        </Container>
        </Col>
  </Row>

  
</Container>


<Footer /> 
        </>
        ) ;
    }
export default UserApprove;